import { render, staticRenderFns } from "./MypageOrdersPage.vue?vue&type=template&id=22332de8&"
import script from "./MypageOrdersPage.vue?vue&type=script&lang=js&"
export * from "./MypageOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports